import ImageUploadBuildingInfos from './ImageUploadBuildingInfo';

export default ImageUploadBuildingInfos;
